import { render } from "./featuresTable.vue?vue&type=template&id=49812074&scoped=true"
import script from "./featuresTable.vue?vue&type=script&lang=js"
export * from "./featuresTable.vue?vue&type=script&lang=js"

import "./featuresTable.vue?vue&type=style&index=0&id=49812074&scoped=true&lang=css"

import exportComponent from "/home/hakii/application-form-proto-admin-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49812074"]])

export default __exports__